import { FlagOutlined } from '@ant-design/icons-vue';
import MissionsList from '@/views/missions/MissionsList.vue';
import MissionRecords from '@/views/missions/MissionRecords.vue';
import MissionReviews from '@/views/missions/MissionReviews.vue';

export const missionsFolderRoute = {
    path: 'missions',
    name: 'Missions',
    redirect: '/missions/missions-list', // 修正重定向路徑
    meta: {
        title: '任務管理',
        icon: FlagOutlined
    },
    children: []
};

export const missionsChildrenRoutes = [
    {
        path: 'missions-list', // 使用相對路徑
        component: MissionsList,
        name: 'MissionsList',
        meta: {
            title: '任務設置'
        }
    },
    {
        path: 'mission-records', // 使用相對路徑
        component: MissionRecords,
        name: 'MissionRecords',
        meta: {
            title: '執行紀錄'
        }
    },
    {
        path: 'mission-reviews', // 使用相對路徑
        component: MissionReviews,
        name: 'MissionReviews',
        meta: {
            title: '任務審核'
        }
    }
];
